import { useEffect, useRef } from "react";
import "../styles/wall.scss";
import useWallStore from "../store/useWallStore";
import { ClimbingBoxLoader } from "react-spinners";
import WallDuplicateRender from "../components/wall/WallDuplicateRender";
import { trackScreen, startPageTimer, trackPageTimeSpent } from "../utils/mixpanel";

const WallLanding = () => {
  const isLoading = useWallStore((state) => state.isLoading);
  const setLoading = useWallStore((state) => state.setLoading);
  const fetchHotspotList = useWallStore((state) => state.fetchHotspotList);
  const hotspotList = useWallStore((state) => state.hotspotList);
  const loadStartTime = useRef(Date.now());

  const init = async () => {
    setLoading(true);
    await fetchHotspotList();
    setLoading(false);
  };

  useEffect(() => {
    init();
    startPageTimer();

    // Track page time on unmount
    return () => {
      trackPageTimeSpent("wall");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Track screen view after loading completes
  useEffect(() => {
    if (!isLoading && hotspotList.length > 0) {
      const loadDuration = Date.now() - loadStartTime.current;
      trackScreen("wall_screen_viewed", {
        hotspot_count: hotspotList.length,
        load_time_ms: loadDuration,
      });
      
    }
  }, [isLoading, hotspotList.length]); // Use length to avoid re-running if list reference changes but content same

  if (isLoading) {
    return (
      <div className="center-container">
        <ClimbingBoxLoader color="#5961FF" size={16} />
      </div>
    );
  }

  return <WallDuplicateRender />;
};

export default WallLanding;
